import { ServiceFetch } from '../service-fetch'

export default class StockIssueTypeModel extends ServiceFetch {
    getStockIssueTypeBy = (data) => this.authFetch({
        url: 'stock-issue-type/getStockIssueTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}